// Reposiory of app-wide domain errors
// (mirrored from backend. todo: combine them)

import { ProviderNames } from "./data/models/Providers";

export const AppErrors = {
    ProviderErrors: 'ProviderErrors'
}

export const ErrorMessages = {

    defaultErrorMessage: () => {
        return `An error occurred.`;
    },

    invalidEmailAddress: (email) => {
        return `Please enter a valid email address.`;
    },

    fixApiTokenError: (provider) => {
        return `The ${provider} API token has expired. Please have the original Adaya account holder login to update it.<br/>For more assistance, please send a screencapture of this message to our Support Team via Live Chat or to hello@adaya.ai`;
    },

    apiRateLimitError: (provider) => {
        return `There have been to many consecutive calls to the ${provider} API for your account. Please wait a few minutes and refresh the page to try again.`;
    },

    passwordValidationError: (password) => {
        return `Password must include a number, a capital letter, and a special character, ie. !@#$%^&*().`;
    },

    noDataError: () => {
        return `No data available.`;
    }

}

export class AdayaError implements Error {
    name: string;
    message: string;
    data: any;

    constructor(message, data?) {
        this.name = 'AdayaError';
        this.message = message;
        this.data = data;

        //console.error('AdayaError:', message, data);
        // todo: log it?
    }

    public toString = (): string => {
        return JSON.stringify({
            name: this.name,
            message: this.message,
            data: this.data
        });
    }

}

export class ProviderError implements Error {
    name: string;
    provider: ProviderNames;
    message: string;
    data: any;

    constructor(providerName: ProviderNames, message: string, data?) {
        this.name = 'ProviderError';
        this.provider = providerName;
        this.message = message;
        this.data = data;
        //console.error(`ProviderError (${providerName}): ${message}`, data);
        // todo: log it? have to schedule job/event...
    }

    public toString = (): string => {
        return JSON.stringify({
            name: this.name,
            provider: this.provider,
            message: this.message,
            data: this.data
        });
    }
}

export const isInvalidTokenError = msg => {
    if (!msg) return false;
    msg = msg.toLowerCase();
    if (msg.indexOf('invalid api key') >= 0) return true;
    if (msg.indexOf('validating access token') >= 0) return true;
    if (msg.indexOf('session has been invalidated') >= 0) return true;
    return false;
}

export const isRateLimitError = msg => {
    if (!msg) return false;
    msg = msg.toLowerCase();
    if (msg.indexOf('too many calls') >= 0) return true;
    if (msg.indexOf('too many requests') >= 0) return true;
    if (msg.indexOf('please wait') >= 0) return true;
    return false;
}